import { useEffect, useState } from "react";
import { getStorage, removeStorage, setStorage } from "../Tools/Storage";

/**
 *
 * @param key do campo armazenado no storage
 * @param type tipo de storage
 * @returns tupla: [ valor, set, remove ]
 * @return valor armazenado no storage
 * @return função para setar valor de storage
 * @return função para remover campo do storage
 */
export function useStorage<T>(
    key: string,
    type: "local" | "session" = "local"
) {
    const [value, setValue] = useState(getStorage<T>(key, type));

    useEffect(() => {
        const storageListener = (event: StorageEvent) => {
            if (event.key === key) {
                setValue(
                    event.newValue ? JSON.parse(event.newValue) : undefined
                );
            }
        };
        window.addEventListener("storage", storageListener);

        return () => window.removeEventListener("storage", storageListener);
    }, [key]);

    return [
        value,
        (value: T) => setStorage(key, value, type),
        () => removeStorage(key, type),
    ];
}
